module.exports = __webpack_public_path__ + "static/profile-f4341c4735f42ae6d5bb48553f848ac3.png";